<template>
    <div class="aside-card" v-if="list.length > 0">
        <div class="aside-card__title">
            <span class="aside-card__title-text" :class="circleColor">
                推荐作品
            </span>
            <span class="aside-card__title-more" @click="$router.push({ name: 'Works' })">更多</span>
        </div>
        <div class="aside-card__content">
            <ul class="aside-card__content-card">
                <li v-for="(item, index) in list" :key="index">
                    <div class="card">
                        <div class="card-image" @click="openDetail(item.id)">
                            <img v-lazy="item.image" />
                        </div>
                        <div class="card-info">
                            <div class="card-info__title">
                                <!-- <img class="card-info__title-avatar" :src="item.avatar || avatarUrl" /> -->
                                <span>{{ item.title }}</span>
                            </div>
                            <!-- <div class="card-info__action">
                                <span class="card-info__action--follow">
                                    <svg-icon icon-class="follow" class-name="icon-follow"></svg-icon>
                                    {{ item.follow }}
                                </span>
                                <span class="card-info__action--collect">
                                    <svg-icon icon-class="collect" class-name="icon-collect"></svg-icon>
                                    {{ item.collect }}
                                </span>
                            </div> -->
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { openWindow } from '@/utils/utils';
import { getWorkList } from '@/api/home';

export default {
    name: 'AsideCard',
    inject: ['reload'],
    props: {
        circleColor: {
            type: String,
            default: 'blue'
        },
        moreUrl: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        list: [],
        avatarUrl: '/static/images/user.png'
    }),
    mounted() {
        this.getWorkList();
    },
    methods: {
        getWorkList() {
            const params = {
                pageSize: 2,
                pageNum: 1
            };
            getWorkList(params).then(({ code, data }) => {
                if (code === 0) {
                    this.list = data.result.map(item => {
                        return {
                            id: item.id,
                            title: item.title,
                            follow: item.viewCount, // 浏览量
                            collect: item.collectionCount, // 点赞量
                            like: item.zanCount, // 收藏量
                            image: item.logo,
                            name: item.user && item.user.name,
                            avatar: item.user && item.user.imageAddress
                        };
                    });
                }
            });
        },
        openDetail(id) {
            openWindow('/#/works/detail/' + id);
        }
    }
};
</script>

<style lang="scss" scoped>
.aside-card {
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(153, 154, 172, 0.07);
    border-radius: 4px;
    padding: 0 10px;

    &__title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 48px;
        border-bottom: 1px solid #eef0fb;

        &-text {
            display: flex;
            align-items: center;
            @include font(rgba(39, 44, 64, 1), 16px, 600);

            &::before {
                content: '';
                display: inline-block;
                margin-right: 6px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
            }

            &.blue::before {
                background-color: rgba(47, 84, 235, 1);
            }

            &.pink::before {
                background-color: rgba(235, 47, 150, 1);
            }

            &.green::before {
                background-color: rgba(19, 194, 194, 1);
            }

            &.purple::before {
                background-color: rgba(114, 46, 209, 1);
            }
        }

        &-more {
            @include font(#c0c4cc, 14px, 400);
            cursor: pointer;

            &:hover {
                color: #717798;
            }
        }
    }

    &__content {
        padding-top: 10px;

        &-card {
            li {
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .card {
                    cursor: pointer;
                    &:hover {
                        .card-image img {
                            transform: scale(1.05);
                        }

                        .card-info__title {
                            color: rgba(47, 84, 235, 1);
                        }
                    }

                    &-image {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 280px;
                        height: 186px;
                        margin: 0 auto;
                        border-radius: 4px;
                        overflow: hidden;

                        img {
                            width: 280px;
                            height: 186px;
                            transition: transform 0.35s;
                        }
                    }

                    &-info {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 40px;
                        color: #a8adc1;

                        &__title {
                            display: flex;
                            align-items: center;
                            flex: 1;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            @include font(#272c40, 14px, 600);

                            &-avatar {
                                width: 20px;
                                height: 20px;
                                border-radius: 50%;
                                margin-right: 10px;
                            }
                        }

                        &__action {
                            font-size: 16px;
                            .icon-follow,
                            .icon-collect {
                                color: #a8adc1;
                            }

                            &--follow {
                                margin-right: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
}

// 小屏
@include mq($small) {
    .aside-card {
        &__title {
            height: 36px;

            &-text {
                @include font(rgba(39, 44, 64, 1), 14px, 600);
            }

            &-more {
                @include font(#c0c4cc, 12px, 400);
            }
        }

        &__content {
            &-card li {
                .card {
                    &-image {
                        width: 205px;
                        height: 140px;

                        img {
                            width: 205px;
                            height: 140px;
                        }
                    }

                    &-info {
                        height: 30px;

                        &__title {
                            @include font(#272c40, 12px, 400);
                        }

                        &__action {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
